export default __webpack_public_path__ + "static/media/USAA.f5d9e7f6.svg";